export default "__VITE_ASSET__pgCmNC31__"